import styles from "./HiddenValueCounter.module.scss"

import type { HiddenValueCounterComponent as Component } from "."

export const HiddenValueCounter: Component = ({ value }) => (
  <span className={styles.value}>{`+${value}`}</span>
)
